export const hireMernStackPageContent = {
  // Helmet Content 
  helmet: {
    title: "Hire MERN Stack Developers | Full-Stack Web Development",
    description: "Hire MERN Stack developers for dynamic, full-stack web applications. Work with skilled experts proficient in MongoDB, Express.js, React.js, & Node.js. Start now!",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-mern.avif)`,
    image: "", // Keep if explicitly needed, otherwise can remove
    mainHeading: "Hire Mernstack Developers",
    content: "Build scalable, high-performance web applications with our expert MERN Stack developers. Whether you're a startup or an enterprise, we provide top-tier development services tailored to your needs.",
    btnText: "Consult our mern stack developers",
    bannerList: [
      { list: "Freelance Contractors" },
      { list: "Full-time Roles" },
      { list: "Global Teams" },
    ],
  },

  // MERN Stack Expertise Section
  MernExpertise: { // Renamed from HireMernstackServicesData for consistency with previous Flutter example
    btnText: "Schedule a Call Today",
    heading: "Our MERN Stack Developer Expertise",
    description: "Our MERN Stack developers specialize in building scalable, high-performance web applications using MongoDB, Express.js, React.js, & Node.js. We ensure smooth integration across the entire tech stack for seamless functionality.",
    servicesData: [
      {
        title: "MERN Stack Consulting",
        description: "Get expert guidance on your MERN Stack project, from architecture planning to performance optimization for the best development results.",
        icon: "/images/hire-page-icons/mern-stack-icon-1.svg",
      },
      {
        title: "MERN Stack Web Development",
        description: " We build dynamic, feature-rich web applications that leverage the full power of the MERN stack, ensuring optimal speed & scalability.",
        icon: "/images/hire-page-icons/mern-stack-icon-2.svg",
      },
      {
        title: "MERN Stack API Development",
        description: "Our team develops secure, high-performing APIs that facilitate seamless communication between different applications & services.",
        icon: "/images/hire-page-icons/mern-stack-icon-3.svg",
      },
      {
        title: "MERN Stack CMS & Portal Development",
        description: "Develop a custom CMS or web portal using the MERN stack for flexible content management & smooth user interactions.",
        icon: "/images/hire-page-icons/mern-stack-icon-4.svg",
      },
      {
        title: "Migration to MERN Stack",
        description: "Seamlessly transition your existing applications to the MERN stack with zero data loss & optimized performance.",
        icon: "/images/hire-page-icons/mern-stack-icon-5.svg",
      },
      {
        title: "Integration with Existing Solutions",
        description: "We ensure smooth integration of your MERN Stack application with third-party services, tools, & platforms for enhanced functionality.",
        icon: "/images/hire-page-icons/mern-stack-icon-6.svg",
      },
      {
        title: "MERN Stack eCommerce Solutions",
        description: "Create fast, scalable, & engaging eCommerce platforms that enhance user experience & drive conversions.",
        icon: "/images/hire-page-icons/mern-stack-icon-7.svg",
      },
      {
        title: "MERN Stack Support & Maintenance",
        description: " Ensure long-term stability & performance with our ongoing support, troubleshooting, & system upgrades.",
        icon: "/images/hire-page-icons/mern-stack-icon-8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "Hire a developer today",
    heading: "Why Choose Bitsclan to Hire ",
    greenHeading: "MERN Developers?",
    subHeading: "At Bitsclan, we build high-performance, scalable web applications using the MERN stack (MongoDB, Express.js, React.js, Node.js). By integrating modern frontend & mobile technologies, we create custom solutions that align with your business goals. Whether you're developing a web platform or a mobile solution, we ensure fast development, smooth performance, & an outstanding user experience across all devices.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "Access vetted talent",
        description: " We connect you with highly skilled MERN stack developers who are experienced, fluent in English, & proficient in full-stack JavaScript development, ensuring seamless communication & execution.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "Find the Right Match Instantly",
        description: "Skip the hassle of sorting through endless resumes. With HireAI, you can instantly access top MERN developers, making your hiring process faster & more efficient.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "Save with Global Hiring",
        description: "Expand your reach beyond local talent & hire top MERN developers worldwide—reducing hiring costs by up to 58% compared to traditional methods.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "Get Real Human Support",
        description: " Our expert recruitment team is available every step of the way, ensuring you hire the best MERN stack developers with confidence.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: {
    heading: "Top MERN Stack Combinations for Exceptional Development",
    description: "Leverage the power of the MERN stack to build dynamic, scalable, & high-performance web applications. Hire expert MERN developers to create seamless, full-stack solutions tailored to your business needs.",
    combinations: [
      {
        title: "MERN (MongoDB + Express.js + React + Node.js)",
        description:
          "MERN is a powerful full-stack JavaScript framework where MongoDB serves as a NoSQL database, Express.js handles backend logic, React builds dynamic UIs, & Node.js runs the server, making it ideal for modern web applications.",
        icons: [
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
          { icon: "express.svg", altText: "Express.js backend framework" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "nodejs.svg", altText: "Node.js backend runtime" },
        ],
      },
      {
        title: "MERN + GraphQL",
        description:
          "GraphQL enables efficient data queries, React provides a dynamic front-end, & Express.js with Node.js ensures scalable backend operations while MongoDB stores flexible NoSQL data.",
        icons: [
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
          { icon: "express.svg", altText: "Express.js backend framework" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "nodejs.svg", altText: "Node.js backend runtime" },
          { icon: "graphql.svg", altText: "GraphQL query language" },
        ],
      },
      {
        title: "MERN + Redux Toolkit",
        description:
          "Redux Toolkit enhances state management, combined with the MERN stack, providing seamless data flow & improved scalability for large-scale applications.",
        icons: [
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
          { icon: "express.svg", altText: "Express.js backend framework" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "nodejs.svg", altText: "Node.js backend runtime" },
          { icon: "redux.svg", altText: "Redux state management toolkit" },
        ],
      },
      {
        title: "MERN + Next.js",
        description:
          "Next.js for server-side rendering (SSR) improves SEO & performance, paired with the MERN stack to build fast, scalable, & SEO-friendly applications.",
        icons: [
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
          { icon: "express.svg", altText: "Express.js backend framework" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "nodejs.svg", altText: "Node.js backend runtime" },
          { icon: "next-js.svg", altText: "Next.js SSR framework" },
        ],
      },
    ],
  },

  // Hire Steps
  hireSteps: {
    btnText: "Let’s Find Your Perfect Developer",
    heading: "Hire MERN Stack Developers in 4 Easy Steps",
    subHeading: "Finding the right MERN stack developer is simple with our streamlined 4-step process. We ensure seamless integration, fast onboarding, & the perfect fit for your project.",
    steps: [
      {
        title: "Choose your Engagement Model",
        description: " Select a model that suits your project—Full-Time, Part-Time, or Hourly—for maximum flexibility & efficiency.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "Screen & Select Mern Stack Developers",
        description: " Explore top MERN developer profiles, shortlist candidates, & find the right match for your team.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "Conduct One-on-One Interview",
        description: "Assess technical expertise through practical & theoretical questions to ensure they meet your project’s needs.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "Onboard Your MERN Stack Developer",
        description: "Once selected, your developer joins your team within 24-48 hours, ready to start working.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: {
    whereStart: "Frontend",
    mainHeading: "Hire Expert MERN Stack Developers for Full-Stack Web Solutions",
    subHeading: "At Bitsclan, we empower your web development journey with a cutting-edge MERN stack, ensuring seamless, scalable, & high-performance applications. Our expert developers specialize in building dynamic, end-to-end web solutions using MongoDB, Express.js, React, & Node.js to meet your business needs.",
    tabs: [
      "Frontend",
      "Backend",
      "Database",
    ],
    tabItems: [
      { tab: "Frontend", name: "ReactJS", icon: "/images/iconthree.png" },
      { tab: "Frontend", name: "Vue.js", icon: "/images/icon4.png" },
      { tab: "Backend", name: "Express.js", icon: "/images/database5.png" },
      { tab: "Backend", name: "Laravel", icon: "/images/tech-stack-icons/laravel.svg" },
      { tab: "Backend", name: "Node.js", icon: "/images/database9.png" },
      { tab: "Database", name: "MongoDB", icon: "/images/db3.png" },
    ],
  },

  // Expert Facts
  expertFacts: {
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our MERN Stack Team",
    facts: [
      { text: "<strong>10+ Skilled MERN Developers: </strong>Our expert team of MERN developers builds powerful, scalable web apps tailored to your needs." },
      { text: "<strong>25+ Years of Combined Experience:</strong> With over 25 years of combined expertise, our team brings deep knowledge in full-stack MERN development." },
      { text: "<strong>Full-Stack Development Mastery:</strong> We specialize in React.js for frontend, Node.js & Express.js for backend, & MongoDB for robust database solutions." },
      { text: "<strong>Cloud-Native & Serverless Solutions:</strong> Our expertise in cloud-native & serverless architectures ensures scalable, future-proof applications." },
      { text: "<strong> Strong DevOps & CI/CD Practices:</strong> With a mature DevOps culture, we streamline workflows for faster, more reliable deployments." },
      { text: "<strong>Experts in High-Performance Web Apps:</strong> We build scalable, data-driven web apps optimized for speed, efficiency, & seamless user experiences." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-mern.avif)`, // Changed from factBackgroundImage
  },

  // App Idea Section
  appIdeaSection: {
    heading: "Turn Your App Idea into a Working Prototype in Just Weeks!",
    content: "Have a great idea but unsure how to bring it to life? Our expert Ruby on Rails developers will help you build a functional prototype in as little as 6-8 weeks. Validate your vision, test user engagement, & lay the groundwork for a successful launch—quickly & efficiently.",
  },

  // Engagement Models (already exists)
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    hiringDetails: [
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // FAQ Section
  faqSection: {
    mainHeading: "Frequently Asked Questions",
    subHeading: "Discover answers to common questions about MERN Stack Development.",
    faqData: [
      {
        id: "collapseOne",
        question: "What is the MERN stack?",
        answer: "The MERN stack is a combination of technologies used to build web applications. It includes MongoDB (a NoSQL database), Express.js (a web framework), React.js (a front-end library), & Node.js (a server-side runtime). These tools work together to create fast, scalable, & dynamic web apps. When you hire a MERN stack developer, you're getting someone who can handle the entire development process from front-end to back-end.",
      },
      {
        id: "collapseTwo",
        question: "Why should I hire a MERN stack developer for my project?",
        answer: "Hiring a MERN stack developer is a great choice if you're looking for someone who can build full-fledged web applications. MERN developers can work across all layers of development, meaning they can design both the front-end & back-end of your application, integrate APIs, & manage databases—all within a unified tech stack. This makes development faster & more efficient because everything works seamlessly together.",
      },
      {
        id: "collapseThree",
        question: "What kind of projects are best suited for MERN stack development?",
        answer: "MERN stack is perfect for building modern web apps like e-commerce platforms, social media sites, real-time chat applications, & content management systems. It’s especially useful for single-page applications (SPAs) where performance & user experience are key. If you're aiming to create a dynamic, interactive web app with a responsive UI, MERN is a solid choice.",
      },
      {
        id: "fourth",
        question: " How long does it take to develop a MERN stack application?",
        answer: "The time it takes to develop a MERN stack application depends on the complexity of the project. A simple app could take a few weeks, while a more complex platform might take a few months. During the initial consultation, a good MERN stack developer will be able to give you an estimated timeline based on your requirements & features.",
      },
      {
        id: "fifth",
        question: "Do I need to know coding to work with a MERN stack developer?",
        answer: "Not at all! You don’t need to know how to code to collaborate effectively with a MERN stack developer. What’s important is that you have a clear understanding of your project goals & functionality. A good developer will guide you through the process, simply explain technical terms, & keep you updated on the progress.",
      },
      {
        id: "sixth",
        question: "How much does it cost to hire a MERN stack developer?",
        answer: "The cost of hiring a MERN stack developer varies depending on their experience, location, & the complexity of your project. On average, hourly rates can range from $30 to $150 per hour. For larger projects, some developers may offer a fixed-price quote. It’s always a good idea to discuss your budget & project requirements upfront to ensure there are no surprises later.",
      },
    ],
  },
};

// You can remove these individual exports if they are now nested within hireMernStackPageContent
// export const tabs = [...]
// export const tabItems = [...]
// export const techCombinations = [...]
// export const HireMernstackBannerList = [...]
// export var mainBannerImg = { ... }
// export const HireMernstackServicesData = [...]
// export const HireMernstackSolutionsData = [...]
// export const HireMernstackSteps = [...]
// export const HireMernstackFactsData = [...]
// export const HireMernstackFaqData = [...]
// export const hiringDetails = [...] // This one is referenced inside hireMernStackPageContent, so it's fine if it stays separately exported if needed elsewhere, but if not, move its content directly into hireMernStackPageContent.hirePageEngagementModels.hiringDetails

// The following exports seem to be unused in the provided HireMernStack component
// & can likely be removed if not used elsewhere:
// export const HireMernstackStacksdata = [...]
// export const HireMernstackBenefitsData = [...]
// export const HireMernstackWhoWeServeData = [...]
// export const HireMernstackPageDeliverData = [...]
// export const HireMernstackSlidesData = [...]